import { render } from "./image_step.vue?vue&type=template&id=64dc3d7d"
import script from "./image_step.vue?vue&type=script&lang=js"
export * from "./image_step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__